import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Table, Select, Input, Button, Tooltip } from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_usm_course_semester_three,
  req_downloadfile_usm_course_semester_three,
} from "../../api";

class CourseWeektimeSemesterThree extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    isShowConfigModal: false,
    isShowAddModal: false,
    isShowEditModal: false,
    isShowCourseModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_course_semester_three(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_course_semester_three(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "教室編號",
        dataIndex: "RoomCode",
        width: 20,
        fixed: "left",
      },
      {
        title: "教室名稱",
        dataIndex: "SpaceStandardTwName",
        width: 40,
        fixed: "left",
      },
      {
        title: "所在建物",
        dataIndex: "BuildingName",
        width: 30,
      },
      {
        title: "保管單位",
        dataIndex: "ShortDepartmentTwName",
        width: 28,
      },
      {
        title: "保管人",
        dataIndex: "CustodianTwName",
        width: 25,
      },
      {
        title: "本學期",
        dataIndex: "YearSemester_F",
        width: 25,
      },
      {
        title: "分鐘數",
        dataIndex: "TimeTotal_F",
        width: 20,
      },
      {
        title: "課堂數",
        dataIndex: "ClassTotal_F",
        width: 20,
      },
      {
        title: "上一學期",
        dataIndex: "YearSemester_S",
        width: 25,
      },
      {
        title: "分鐘數",
        dataIndex: "TimeTotal_S",
        width: 20,
      },
      {
        title: "課堂數",
        dataIndex: "ClassTotal_S",
        width: 20,
      },
      {
        title: "上上學期",
        dataIndex: "YearSemester_T",
        width: 25,
      },
      {
        title: "分鐘數",
        dataIndex: "TimeTotal_T",
        width: 20,
      },
      {
        title: "課堂數",
        dataIndex: "ClassTotal_T",
        width: 20,
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      default:
    }
    this.setState({ item: item });
  };

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchField, searchValue } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="BuildingName">所在大樓</Select.Option>
          <Select.Option value="RoomCode">空間編號</Select.Option>
          <Select.Option value="SpaceStandardTwName">
            空間中文名稱
          </Select.Option>
          <Select.Option value="ShortDepartmentTwName">保管單位</Select.Option>
          <Select.Option value="CustodianTwName">保管人</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "4px" }}></i>{" "}
          匯出
        </Button>
        <p></p>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
        </Card>
      </>
    );
  }
}
export default connect(
  (state) => ({ user: state.user }),
  {}
)(CourseWeektimeSemesterThree);
